export const SESSION_HINT_COOKIE = "repackify-signed-in";

export function isSessionCookie(name: string, sessionCookieName: string): boolean {
  return name === sessionCookieName || name.startsWith(`${sessionCookieName}.`);
}

export function sessionHintHeader(hasSession: boolean, secure: boolean): string {
  const attributes = `Path=/; SameSite=Lax${secure ? "; Secure" : ""}`;
  return hasSession
    ? `${SESSION_HINT_COOKIE}=1; ${attributes}`
    : `${SESSION_HINT_COOKIE}=; Max-Age=0; ${attributes}`;
}
